import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { visibleAssetsListSelctor, pinnedAssetsSelector } from '../../features/assets/assetsSlice';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import { Divider } from '@mui/material';
import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';
import AssetListItem from './AssetListItem';






const AssetList = () => {
    const dimentions = useSelector(liveTrackinglayoutSelector);

    const visibleAssetsList = useSelector(visibleAssetsListSelctor);
    const pinnedAssets = useSelector(pinnedAssetsSelector);

    const buildAssetList = () => {
        return visibleAssetsList.map((assetId, index) =>
            <Fragment key={assetId}>
                <AssetListItem
                    assetId={assetId}
                    pinned={pinnedAssets.indexOf(assetId) !== -1}
                />
                {
                    index < visibleAssetsList.length - 1 && <Divider component="li" />
                }

            </Fragment>

        )
    }

    return (

        <div style={{ ...dimentions.lowersidebar, overflow: 'auto', }}>
            <Paper elevation={3}>
                <List dense>
                    {buildAssetList()}
                </List>
            </Paper>
        </div>


    );
}

export default React.memo(AssetList);

